<template>
  <div id="app">
    <Loading v-if="state.loading" />


    <navbar  v-if="!$route.path.includes('trade') && !$route.path.includes('goldTrade')"/>
    <div class="site">
<transition name="main" enter-active-class="animate__animated animate__fadeIn"  leave-active-class=" animate__animated  animate__fadeIn" >
  <router-view
               />
</transition>

    </div>
    <the-footer v-if="!$route.path.includes('auth') && !$route.path.includes('trade') && !$route.path.includes('panel')"/>
  </div>
</template>

<style lang="scss">
.site{
  margin-top: 50px;
}
</style>
<script>
import Navbar from "./views/Navbar/Navbar";
import TheFooter from "./views/Footer/the-footer";
import Loading from "@/views/Loading";
export default {
  components: {Loading, TheFooter, Navbar},
  mounted() {
    this.$socket()
  }
}
</script>